<template>
	<div>
		<!-- <div class="row mb-2">
			<div class="col-12">
				<div class="card sumirCelular">
					<div class="d-flex align-items-center w-100">
						<div class="align-items-center justify-content-center">
							<img src="@/assets/images/logo-256x256.png" alt="Mooli Logo" class="ml-3 mr-3" width="150">
						</div>
						<div class="w-75">
							<h2 class="font-weight-bold mb-0">Bem vindo ao ACECE</h2>
							<span class="font-16 font-weight-bold">{{ dadosEscola.nome }}</span><br>
							<span class="font-16 font-weight-bold">{{diaDaSemana}} | {{horaAtual}}</span>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<!-- atalhos -->
		<div class="cards-3">
			<div class="card atalho sumirCelular">
				<div class="px-4 h-100">
					<div class="d-flex align-items-center w-100">
						<div class="align-items-center">
							<img src="@/assets/images/logo-256x256.png" alt="Mooli Logo" class="mr-3" width="150">
						</div>
						<div class="w-75">
							<h2 class="font-weight-bold mb-0">Boas vindas ao ACECE</h2>
							<span class="font-16 font-weight-bold"><i class="fas fa-user mr-1 ml-1 font-14"></i>{{ dadosUsuario.usuarioNome }}</span><br>
							<span class="font-16 font-weight-bold"><i class="fas fa-school mr-1 font-14"></i>{{ dadosEscola.nome }}</span><br>
							<span class="font-16 font-weight-bold"><i class="fas fa-clock mr-1 font-14"></i>{{diaDaSemana}} | {{horaAtual}}</span>
						</div>
					</div>
					<div class="descCard">
						<span>Este sistema foi cuidadosamente desenvolvido para otimizar suas tarefas, 
							liberando tempo precioso para que você possa se dedicar ao que realmente importa: 
							o contato humano, a escuta atenta e o acolhimento caloroso.
						</span>
					</div>
				</div>
			</div>
			<div class="card cursor-pointer atalho btnHover">
				<router-link to="/cadastros">
					<div class="card-body h-100">
						<div class="d-flex justify-content-center">
							<h4 class="font-weight-bold">CADASTROS</h4>
						</div>
						<div class="d-flex justify-content-center">
							<span>Gerencie os cadastros</span>
						</div>
						<div class="d-flex align-self-center justify-content-center mt-4">
							<img src="@/assets/images/atalho-1.png" alt="atalho" width="170">
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div class="cards-4 mt-2">
			<div class="card cursor-pointer atalho btnHover">
				<router-link to="/agenda">
					<div class="card-body h-100">
						<div class="d-flex justify-content-center">
							<h4 class="font-weight-bold">AGENDA</h4>
						</div>
						<div class="d-flex justify-content-center">
							<span>Agende próximos encontros</span>
						</div>
						<div class="d-flex align-self-center justify-content-center mt-4">
							<img src="@/assets/images/atalho-2.png" alt="atalho" width="170">
						</div>
					</div>
				</router-link>
			</div>
			<div class="card cursor-pointer atalho btnHover">
				<router-link to="/adicionar">
					<div class="card-body h-100">
						<div class="d-flex justify-content-center">
							<h4 class="font-weight-bold">CADASTRAR</h4>
						</div>
						<div class="d-flex justify-content-center">
							<span>Encontre as perguntas aqui</span>
						</div>
						<div class="d-flex align-self-center justify-content-center mt-4">
							<img src="@/assets/images/atalho-3.png" alt="atalho" width="170">
						</div>
					</div>
				</router-link>
			</div>
			<div class="card cursor-pointer atalho btnHover">
				<router-link to="/relatorio">
					<div class="card-body h-100">
						<div class="d-flex justify-content-center">
							<h4 class="font-weight-bold">RELATÓRIO</h4>
						</div>
						<div class="d-flex justify-content-center">
							<span>Veja as estatística </span>
						</div>
						<div class="d-flex align-self-center justify-content-center mt-4">
							<img src="@/assets/images/atalho-4.png" alt="atalho" width="170">
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div class="cards-5 mt-2 mb-3" v-if="dadosUsuario.usuarioAdmin">
			<div class="card cursor-pointer atalho btnHover">
				<router-link to="/logins">
					<div class="card-body h-100">
						<div class="d-flex justify-content-center">
							<h4 class="font-weight-bold">LOGIN</h4>
						</div>
						<div class="d-flex justify-content-center">
							<span>Gerencie os logins</span>
						</div>
						<div class="d-flex align-self-center justify-content-center mt-4">
							<img src="@/assets/images/atalho-5.png" alt="atalho" width="170">
						</div>
					</div>
				</router-link>
			</div>
			<div class="card cursor-pointer atalho btnHover">
				<router-link to="/editarEscola">
					<div class="card-body h-100">
						<div class="d-flex justify-content-center">
							<h4 class="font-weight-bold">ESCOLAS</h4>
						</div>
						<div class="d-flex justify-content-center">
							<span>Gerencie as escolas</span>
						</div>
						<div class="d-flex align-self-center justify-content-center mt-4">
							<img src="@/assets/images/atalho-6.png" alt="atalho" width="170">
						</div>
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'Página_Inicial',
	data() {
		return {
			diaDaSemana: '',
			horaAtual: ''
		}
	},
	computed: {
		... mapState({
			tokenSessao: state => state.tokenSessao,
			dadosUsuario: state => state.dadosUsuario,
			dadosEscola: state => state.dadosEscola,
		})
	},
	methods: {
		obterDiaDaSemanaAtual() {
			const diasDaSemana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
			const hoje = new Date();
			const dia = hoje.getDay();
			this.diaDaSemana = diasDaSemana[dia];
		},
		obterHoraAtual() {
			const agora = new Date();
			const horas = agora.getHours();
			const minutos = agora.getMinutes();
			const minutosFormatados = minutos < 10 ? `0${minutos}` : minutos;
			const horasFormatada = horas < 10 ? `0${horas}` : horas;

			this.horaAtual = `${horasFormatada}:${minutosFormatados}`;
		}
	},
	mounted() {
		let ref = this;

		this.$axios.interceptors.request.use(function(config) {
			if (ref.tokenSessao != null && ref.dadosUsuario != null) {
				config.headers.Authorization = 'Bearer '+ ref.tokenSessao +'@@@'+ ref.dadosUsuario.usuarioemail;
			}

			return config;
		});

		this.obterDiaDaSemanaAtual()
		this.obterHoraAtual()
		setInterval(this.obterHoraAtual, 1000);
	}
}

</script>

<style scoped>

.row {
	margin: 0;
}

.row>div {
	padding: 0;
}

.card {
	margin-bottom: 0;
	/* background: radial-gradient(at center, #313438 0%, #222427 100%); */
}

h6 {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.btnHover {
	box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.1);
}

.btnHover:hover {
	background-color: rgba(49, 49, 49, 0.705); 
	box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.281);
	transform: scale(1.009);
}

.descCard {
	position: absolute;
	bottom: 25px;
	left: 30px;
	right: 30px;
	font-size: 16px;
}

.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}

.atalho{
	min-height: 300px;
}

.cards-3 {
   display: grid;
   grid-template-columns: 2fr 1fr;
   gap: 0.5rem;
   padding: 0;
   list-style-type: none;
}

.cards-4 {
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   gap: 0.5rem;
   padding: 0;
   list-style-type: none;
}
.cards-5 {
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 0.5rem;
   padding: 0;
   list-style-type: none;
}

.sumirCelular {
   background-image: url("../assets/images/stars-bg-3.png");
   /* background-image: url('https://cdn.discordapp.com/banners/708083259694645370/a_9d5bb56d5f1247c5c4f339360622f5f0.gif?size=480'); */
   background-repeat: no-repeat;
   background-position-x: right;
   background-position-y: 65%;
   background-size: cover;
}

.btnHover {
	box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.1);
   background-image: url("../assets/images/bg-atalhos.png");
}

@media  screen and (max-width: 1000px) {
   .cards-3 {
		display: grid;
		grid-template-columns: 1fr;
		gap: 0.5rem;
		padding: 0;
		list-style-type: none;
	}

	.cards-4 {
		display: grid;
		grid-template-columns: 1fr;
		gap: 0.5rem;
		padding: 0;
		list-style-type: none;
	}

	.cards-5 {
		display: grid;
		grid-template-columns: 1fr;
		gap: 0.5rem;
		padding: 0;
		list-style-type: none;
	}
}
</style>